const gaqlerrCannotCallFOOonBARTYPEvalue = (foo, bar) => new Error(
  `Cannot call ${foo} on ${bar} value.`)

const gaqlerrIndexOutOfBounds = idx => new Error(
  `ReqlNonExistanceError: Index out of bounds: ${idx}`)

const gaqlerrQueryNotFound = queryname => new Error(
  `Query function not found: "${queryname}"`)

const gaqlerrQueryInvalidReturn = queryname => new Error(
  `Query function returned invalid value: "${queryname}". `
    + 'A valid query state object (qst) must be returned.')

const gaqlerrArgsNthTypeMustBe = (queryId, nth, argtype) => new Error(
  `"${queryId}" argument ${nth} must be of type "${argtype}".`)

const gaqlerrArgsNumber = (queryId, min = 0, given = 1, max = Infinity) => {
  const msgatleast = 'takes at least :num :argument, :given provided.'
  const msgatmost = 'takes at most :num :argument, :given provided.'
  const msgexact = 'takes :num :argument, :given provided.'
  const msgresolve = (msg, queryId, num, given) => `"${queryId}" ` + msg
    .replace(/:num/, num)
    .replace(/:given/, given)
    .replace(/:argument/, num === 1 ? 'argument' : 'arguments')

  return new Error(min === max
    ? msgresolve(msgexact, queryId, min, given)
    : given < min
      ? msgresolve(msgatleast, queryId, min, given)
      : msgresolve(msgatmost, queryId, max, given))
}

const gaqlerrArgsNumberOneOf = (queryId, argsNum, given) => new Error(
  `Got ${given} arguments to ${queryId} (expected ${argsNum.join(' or ')})`)

const gaqlerrExpectedTypeFOOFound = (foo, bar) => new Error(
  `Expected type ${foo} but found ${bar}`)

const gaqlerrExpectedTypeSTRINGFound = bar => (
  gaqlerrExpectedTypeFOOFound('STRING', bar))

const gaqlerrAttributeNotFound = (fieldname, obj) => new Error(
  `No attribute "${fieldname}" in object \`${JSON.stringify(obj)}\``)

const gaqlerrQueryCannotUseNestedRow = () => new Error(
  'Cannot use .row in nested queries. Use functions instead')

const gaqlerrCannotReduceOverEmptyStream = () => new Error(
  `Cannot reduce over an empty stream.`)

export {
  gaqlerrIndexOutOfBounds,
  gaqlerrCannotCallFOOonBARTYPEvalue,
  gaqlerrQueryNotFound,
  gaqlerrQueryInvalidReturn,
  gaqlerrQueryCannotUseNestedRow,
  gaqlerrArgsNumber,
  gaqlerrArgsNumberOneOf,
  gaqlerrArgsNthTypeMustBe,
  gaqlerrExpectedTypeFOOFound,
  gaqlerrExpectedTypeSTRINGFound,
  gaqlerrAttributeNotFound,
  gaqlerrCannotReduceOverEmptyStream
}
